import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { State } from '../contexts/GlobalState';
import variables from '../theme/variables';
import { ReactComponent as SoundOn } from '../assets/icons/SoundOnIcon.svg';

const useStyles = createUseStyles(
    {
        btn: {
            color: variables.palette.white,
            position: 'sticky',
            top: 21,
            right: 30,
            zIndex: 10000,
        },

        muteBtnWrap: {
            position: 'absolute',
            height: 'calc(100% - 100px)',
            right: 30,
            top: 21 + variables.msftHeaderHeightMobile,

            '@media (min-width: 860px)': {
                top: 21 + variables.msftHeaderHeight,
            },

            '@media (min-width: 1024px)': {
                top: 45 + variables.msftHeaderHeight,
            },
        },
    },
    { name: 'MuteButton' }
);

export default function MuteButton() {
    const classes = useStyles();
    const { muted, setMuted } = useContext(State);

    return (
        <div className={classes.muteBtnWrap}>
            <button
                onClick={() => setMuted(!muted)}
                className={classes.btn}
                style={{ opacity: muted ? 0.5 : 1 }}
            >
                <SoundOn />
            </button>
        </div>
    );
}
